{
  "interface": "Interfaz",
  "newInterface": "Nueva interfaz",
  "updateInterface": "Editar interfaz",
  "generateNewInterface": "Generar una nueva interfaz",
  "tabs": {
    "mobileApp": {
      "title": "Aplicación movil",
      "column": {
        "organizationName": "Nombre de la organización",
        "name": "Nombre de la interfaz",
        "deviceTypes": "Tipo de dispositivo",
        "updatedAt": "Fecha de actualización"
      },
      "form": {
        "information": {
          "title": "Información",
          "organizationName": "Nombre de la organización",
          "name": "Nombre",
          "description": "Descripción"
        },
        "deviceTypes": {
          "title": "Tipo de dispositivo",
          "label": "Tipos",
          "add": "Añadir",
          "save": "Guardar",
          "cancel": "Cancelar",
          "noLabel": "Tipo desconocido"
        },
        "validation": {
          "name": "El nombre de la interfaz es obligatorio",
          "nameFormat": "El nombre de la interfaz no puede contener caracteres alfanuméricos ni guiones bajos",
          "uniqueName": "El nombre de la interfaz debe ser único"
        }
      },
      "empty": "No hay ninguna interfaz disponible"
    },
    "thirdPartyApp": {
      "title": "Aplicaciones de terceros",
      "column": {
        "organizationName": "Nombre de la organización",
        "interfaceName": "Nombre de la interfaz",
        "authMethod": "Método de autentificación",
        "profile": "Perfil",
        "updatedAt": "Fecha de actualización",
        "status": "Estado"
      },
      "status": {
        "active": "Activa",
        "inactive": "Inactiva"
      },
      "authMethod": {
        "clientGrant": "Client Grant",
        "mtls": "mTLS",
        "userCredentials": "Identificación del cliente"
      },
      "form": {
        "title": "Información",
        "organizationName": "Nombre de la organización",
        "name": "Nombre de la interfaz",
        "profile": {
          "label": "Perfil",
          "placeholder": "Seleccionar un perfil"
        },
        "sectors": {
          "label": "Redes",
          "placeholder": "Seleccionar las redes"
        },
        "authenticationType": {
          "label": "Tipo de autentificación",
          "clientGrant": "ClientGrant",
          "mtls": "mTLS"
        },
        "validation": {
          "organizationName": "El nombre de la organización es obligatorio",
          "name": "El nombre es obligatorio",
          "profile": "El perfil es obligatorio",
          "sectors": "La selección de una o más redes es obligatoria",
          "authenticationType": "El tipo de autentificación es obligatorio",
          "nameFormat": "El nombre de la interfaz no puede contener caracteres alfanuméricos ni guiones bajos",
          "uniqueName": "El nombre de la interfaz debe ser único"
        },
        "update": {
          "sidePanelTitle": "Modificación de la interfaz de terceros",
          "information": {
            "title": "Importante",
            "content": "Si ha perdido el cliente secreto, elimine esta interfaz y cree una nueva"
          }
        },
        "confirmCancelUpdate": {
          "title": "Cancelar la actualización de la interfaz",
          "message": "¿Seguro que desea cancelar la actualización de la interfaz?"
        },
        "confirmCancelCreate": {
          "title": "Cancelar la creación de la interfaz",
          "message": "¿Seguro que desea cancelar la creación de la interfaz?"
        }
      },
      "creationModalSuccess": {
        "header": {
          "title": "Correcta",
          "info": "Advertencia: guarde esta información, una vez cerrada esta página, no podrá consultarla."
        },
        "clientId": {
          "label": "ClientId"
        },
        "secret": {
          "label": "Secreto"
        },
        "copyToClipboard": {
          "copied": "Copiado",
          "buttonTitle": "copiar en el portapapeles"
        }
      },
      "empty": "No hay ninguna aplicación de terceros disponible",
      "licenseMessage": {
        "disableNewInterface": "Se ha alcanzado el límite de la licencia, se ha desactivado la creación de la interfaz.",
        "disableActivateInterface": "Se ha alcanzado el límite de la licencia, se ha desactivado la activación de la interfaz."
      }
    }
  },
  "action": {
    "delete": {
      "confirm": {
        "title": "Eliminar la interfaz",
        "message": "La interfaz {name} se va a eliminar."
      }
    },
    "deactivate": {
      "confirm": {
        "title": "Desactivar la interfaz",
        "message": "La interfaz {name} se va a desactivar."
      }
    },
    "activate": {
      "confirm": {
        "title": "Activar la interfaz",
        "message": "La interfaz {name} se va a activar."
      }
    }
  }
}
